import './index.css'
import cn from 'clsx'

import React from 'react'
import Content from './content'
import Footer from './footer'
import Header from './header'
export type Props = {
  className?: string
  children?: React.ReactNode
}

/**
 * A container component that provides a structured panel layout with header, content, and footer sections
 * @param className - Additional CSS classes to apply to the panel container
 * @param children - Content to display inside the panel
 * @returns Panel div element with configurable styling and child components
 */
const Panel = (props: Props): React.ReactElement<'div'> => {
  const { className, children } = props
  return <div className={cn('Panel', className)}>{children}</div>
}

Panel.Header = Header
Panel.Footer = Footer
Panel.Content = Content
export default Panel
